import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShieldCheck, Cookie } from "lucide-react";
import { api } from "../lib/api";

export default function ConsentBanner() {
  const { pathname } = useLocation();
  const [show, setShow] = useState(() => !localStorage.getItem("pp_consent") || !localStorage.getItem("pp_cookies"));
  if (!show || pathname === "/consentement-acces") return null;
  const save = (cookies) => {
    localStorage.setItem("pp_consent", "1");
    localStorage.setItem("pp_cookies", cookies); // "all" | "essential"
    localStorage.setItem("pp_consent_at", new Date().toISOString());
    const optional = cookies === "all";
    api.logConsent({ categories: { necessary: true, preferences: optional, analytics: optional }, source: "banner", policy_version: "1.0" }).catch(() => {});
    setShow(false);
  };
  return (
    <div style={{ position: "fixed", bottom: 18, left: "50%", transform: "translateX(-50%)", zIndex: 70, width: 720, maxWidth: "94vw" }} data-testid="consent-banner">
      <div className="card gold-border" style={{ boxShadow: "0 20px 60px rgba(0,0,0,.5)" }}>
        <div style={{ display: "flex", gap: 12, alignItems: "flex-start", marginBottom: 12 }}>
          <ShieldCheck size={24} color="var(--gold)" style={{ flexShrink: 0, marginTop: 2 }} />
          <div style={{ fontSize: 13, color: "var(--muted)", lineHeight: 1.5 }}>
            PROGÈRE PUNCH collecte la position GPS au moment du punch et certains renseignements pour la gestion des présences,
            conformément à la <strong style={{ color: "var(--text)" }}>Loi 25 (Québec)</strong>.
          </div>
        </div>
        <div style={{ display: "flex", gap: 12, alignItems: "flex-start", marginBottom: 16 }}>
          <Cookie size={24} color="var(--gold)" style={{ flexShrink: 0, marginTop: 2 }} />
          <div style={{ fontSize: 13, color: "var(--muted)", lineHeight: 1.5 }}>
            Nous utilisons des <strong style={{ color: "var(--text)" }}>témoins (cookies)</strong> essentiels au fonctionnement (session, sécurité) et,
            avec votre accord, des témoins optionnels (préférences, mesure d'audience).{" "}
            <Link to="/confidentialite" style={{ color: "var(--gold)" }}>Politique de confidentialité et des témoins</Link>.
          </div>
        </div>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", flexWrap: "wrap" }}>
          <button className="btn btn-outline btn-sm" onClick={() => save("essential")} data-testid="consent-essential">Refuser les témoins optionnels</button>
          <button className="btn btn-gold btn-sm" onClick={() => save("all")} data-testid="consent-accept">Tout accepter</button>
        </div>
      </div>
    </div>
  );
}
